/** user-htd theme registry — HTD redesign with Blue, Light Blue and Red. */

export interface ThemeMetadata {
  id: string
  name: string
  displayName: string
  folder: string
  description?: string
  colorScheme: {
    primary: string
    secondary: string
  }
  assets: {
    styles: string[]
    scripts: string[]
    favicon: string
    logo: string
  }
  status: 'active' | 'beta' | 'deprecated'
}

const THEME_STYLES = [
  '/css/style.css',
  '/css/bootstrap.min.css',
  '/css/animate.min.css',
  '/css/fontawesome-all.min.css',
]

export const AVAILABLE_THEMES: Record<string, ThemeMetadata> = {
  'huay-today-blue': {
    id: 'huay-today-blue',
    name: 'HuayTodayBlue',
    displayName: 'HuayToday Blue',
    folder: 'HuayToday-Blue',
    description: 'HTD redesign โทนน้ำเงิน',
    colorScheme: {
      primary: '#067FD0',
      secondary: '#151A7B',
    },
    assets: {
      styles: [...THEME_STYLES],
      scripts: [],
      favicon: '/img/favicon.ico',
      logo: '/img/logo-m.png',
    },
    status: 'active',
  },
  'huay-today-lightblue': {
    id: 'huay-today-lightblue',
    name: 'HuayTodayLightBlue',
    displayName: 'HuayToday Light Blue',
    folder: 'HuayToday-LightBlue',
    description: 'HTD redesign โทนฟ้าอ่อน',
    colorScheme: {
      primary: '#0EA5E9',
      secondary: '#0284C7',
    },
    assets: {
      styles: [...THEME_STYLES],
      scripts: [],
      favicon: '/img/favicon.ico',
      logo: '/img/logo-m.png',
    },
    status: 'active',
  },
  'huay-today-red': {
    id: 'huay-today-red',
    name: 'HuayTodayRed',
    displayName: 'HuayToday Red',
    folder: 'HuayToday-Red',
    description: 'HTD redesign โทนแดง',
    colorScheme: {
      primary: '#DC2626',
      secondary: '#991B1B',
    },
    assets: {
      styles: [...THEME_STYLES],
      scripts: [],
      favicon: '/img/favicon.ico',
      logo: '/img/logo-m.png',
    },
    status: 'active',
  },
  /** Backward-compatible alias for localStorage from early user-htd builds. */
  'huay-htd': {
    id: 'huay-htd',
    name: 'HuayHtdLegacy',
    displayName: 'HuayToday Blue (legacy)',
    folder: 'HuayToday-Blue',
    colorScheme: {
      primary: '#067FD0',
      secondary: '#151A7B',
    },
    assets: {
      styles: [...THEME_STYLES],
      scripts: [],
      favicon: '/img/favicon.ico',
      logo: '/img/logo-m.png',
    },
    status: 'deprecated',
  },
}

export const getActiveThemes = (): ThemeMetadata[] => {
  return Object.values(AVAILABLE_THEMES).filter((t) => t.status === 'active')
}

export const getThemeById = (id: string): ThemeMetadata | null => {
  return AVAILABLE_THEMES[id] ?? null
}

export const getThemeIds = (): string[] => Object.keys(AVAILABLE_THEMES)

export const getDefaultTheme = (): ThemeMetadata => AVAILABLE_THEMES['huay-today-blue']
